(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8552],{

/***/ 66242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(27192);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(55113);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(28979);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(76087);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/cardClasses.js

function getCardUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCard', slot);
}
const cardClasses = (0,generateUtilityClasses/* default */.Z)('MuiCard', ['root']);
/* harmony default export */ var Card_cardClasses = ((/* unused pure expression or super */ null && (cardClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/Card.js


const _excluded = ["className", "raised"];











const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardUtilityClass, classes);
};

const CardRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card = /*#__PURE__*/react.forwardRef(function Card(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCard'
  });

  const {
    className,
    raised = false
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    raised
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Card_Card = (Card);

/***/ }),

/***/ 72879:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us",
      function () {
        return __webpack_require__(13009);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i5": function() { return /* reexport */ CarouselArrows; },
  "A0": function() { return /* reexport */ CarouselDots; }
});

// UNUSED EXPORTS: CarouselArrowIndex

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
;// CONCATENATED MODULE: ./src/components/carousel/CarouselDots.js
// @mui





// ----------------------------------------------------------------------
var RootStyle = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "rounded";
    }
})(function(param) {
    var rounded = param.rounded;
    return {
        display: "flex",
        listStyle: "none",
        alignItems: "center",
        justifyContent: "center",
        "& li": {
            width: 18,
            height: 18,
            opacity: 0.32,
            cursor: "pointer"
        },
        "& li.slick-active": (0,_object_spread/* default */.Z)({
            opacity: 1
        }, rounded && {
            "& .dotActive": {
                width: 16,
                borderRadius: 6
            }
        })
    };
});
var DotWrapStyle = (0,styled/* default */.ZP)("div")(function() {
    return {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    };
});
var DotStyle = (0,styled/* default */.ZP)("span")(function(param) {
    var theme = param.theme;
    return {
        width: 8,
        height: 8,
        borderRadius: "50%",
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.short
        })
    };
});
// ----------------------------------------------------------------------
function CarouselDots(props) {
    var color = props === null || props === void 0 ? void 0 : props.color;
    var rounded = (props === null || props === void 0 ? void 0 : props.rounded) || false;
    return {
        appendDots: function(dots) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RootStyle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    rounded: rounded,
                    component: "ul"
                }, props), {
                    children: dots
                }))
            });
        },
        customPaging: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DotWrapStyle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DotStyle, {
                    className: "dotActive",
                    sx: {
                        bgcolor: color || "primary.main"
                    }
                })
            });
        }
    };
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./src/components/Iconify.js + 1 modules
var Iconify = __webpack_require__(34444);
// EXTERNAL MODULE: ./src/components/animate/index.js + 16 modules
var animate = __webpack_require__(80104);
;// CONCATENATED MODULE: ./src/components/carousel/CarouselArrows.js





// @mui


//


// ----------------------------------------------------------------------
var BUTTON_SIZE = 40;
var ArrowStyle = (0,styled/* default */.ZP)(animate/* IconButtonAnimate */.w_, {
    shouldForwardProp: function(prop) {
        return prop !== "filled";
    }
})(function(param) {
    var filled = param.filled, theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        width: BUTTON_SIZE,
        height: BUTTON_SIZE,
        cursor: "pointer",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            color: theme.palette.text.primary
        }
    }, filled && {
        opacity: 0.48,
        borderRadius: Number(theme.shape.borderRadius) * 1.5,
        color: theme.palette.common.white,
        backgroundColor: theme.palette.grey[900],
        "&:hover": {
            opacity: 1,
            color: theme.palette.common.white,
            backgroundColor: theme.palette.grey[900]
        }
    });
});
// ----------------------------------------------------------------------
CarouselArrows.propTypes = {
    children: (prop_types_default()).node,
    customIcon: prop_types_default().oneOfType([
        (prop_types_default()).element,
        (prop_types_default()).string
    ]),
    filled: (prop_types_default()).bool,
    onNext: (prop_types_default()).func,
    onPrevious: (prop_types_default()).func
};
function CarouselArrows(_param) {
    var _filled = _param.filled, filled = _filled === void 0 ? false : _filled, customIcon = _param.customIcon, onNext = _param.onNext, onPrevious = _param.onPrevious, children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "filled",
        "customIcon",
        "onNext",
        "onPrevious",
        "children"
    ]);
    var theme = (0,useTheme/* default */.Z)();
    var isRTL = theme.direction === "rtl";
    var style = {
        position: "absolute",
        mt: -2.5,
        top: "50%",
        zIndex: 9
    };
    if (children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: "arrow left",
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                        left: 0
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowStyle, {
                        filled: filled,
                        onClick: onPrevious,
                        children: leftIcon(customIcon, isRTL)
                    })
                }),
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: "arrow right",
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                        right: 0
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowStyle, {
                        filled: filled,
                        onClick: onNext,
                        children: rightIcon(customIcon, isRTL)
                    })
                })
            ]
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        direction: "row",
        spacing: 1
    }, other), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowStyle, {
                className: "arrow left",
                filled: filled,
                onClick: onPrevious,
                children: leftIcon(customIcon, isRTL)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowStyle, {
                className: "arrow right",
                filled: filled,
                onClick: onNext,
                children: rightIcon(customIcon, isRTL)
            })
        ]
    }));
}
// ----------------------------------------------------------------------
var leftIcon = function(customIcon, isRTL) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
        icon: customIcon ? customIcon : "eva:arrow-right-fill",
        sx: (0,_object_spread/* default */.Z)({
            width: 20,
            height: 20,
            transform: " scaleX(-1)"
        }, isRTL && {
            transform: " scaleX(1)"
        })
    });
};
var rightIcon = function(customIcon, isRTL) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
        icon: customIcon ? customIcon : "eva:arrow-right-fill",
        sx: (0,_object_spread/* default */.Z)({
            width: 20,
            height: 20
        }, isRTL && {
            transform: " scaleX(-1)"
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
;// CONCATENATED MODULE: ./src/components/carousel/CarouselArrowIndex.js





// @mui


//

// ----------------------------------------------------------------------
var CarouselArrowIndex_RootStyle = (0,styled/* default */.ZP)(Box/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        zIndex: 9,
        display: "flex",
        alignItems: "center",
        position: "absolute",
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        color: theme.palette.common.white,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.grey[900], 0.48)
    };
});
var CarouselArrowIndex_ArrowStyle = (0,styled/* default */.ZP)(IconButton/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        padding: 6,
        opacity: 0.48,
        color: theme.palette.common.white,
        "&:hover": {
            opacity: 1
        }
    };
});
// ----------------------------------------------------------------------
CarouselArrowIndex.propTypes = {
    customIcon: prop_types_default().oneOfType([
        (prop_types_default()).element,
        (prop_types_default()).string
    ]),
    index: (prop_types_default()).number,
    onNext: (prop_types_default()).func,
    onPrevious: (prop_types_default()).func,
    total: (prop_types_default()).number
};
function CarouselArrowIndex(_param) {
    var index = _param.index, total = _param.total, onNext = _param.onNext, onPrevious = _param.onPrevious, customIcon = _param.customIcon, other = (0,_object_without_properties/* default */.Z)(_param, [
        "index",
        "total",
        "onNext",
        "onPrevious",
        "customIcon"
    ]);
    var theme = (0,useTheme/* default */.Z)();
    var isRTL = theme.direction === "rtl";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CarouselArrowIndex_RootStyle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselArrowIndex_ArrowStyle, {
                size: "small",
                onClick: onPrevious,
                children: CarouselArrowIndex_leftIcon(customIcon, isRTL)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "subtitle2",
                children: [
                    index + 1,
                    "/",
                    total
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselArrowIndex_ArrowStyle, {
                size: "small",
                onClick: onNext,
                children: CarouselArrowIndex_rightIcon(customIcon, isRTL)
            })
        ]
    }));
}
// ----------------------------------------------------------------------
var CarouselArrowIndex_leftIcon = function(customIcon, isRTL) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
        icon: customIcon ? customIcon : "eva:arrow-right-fill",
        sx: (0,_object_spread/* default */.Z)({
            width: 20,
            height: 20,
            transform: " scaleX(-1)"
        }, isRTL && {
            transform: " scaleX(1)"
        })
    });
};
var CarouselArrowIndex_rightIcon = function(customIcon, isRTL) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
        icon: customIcon ? customIcon : "eva:arrow-right-fill",
        sx: (0,_object_spread/* default */.Z)({
            width: 20,
            height: 20
        }, isRTL && {
            transform: " scaleX(-1)"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/carousel/index.js





/***/ }),

/***/ 13009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ About; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./src/layouts/index.js + 23 modules
var layouts = __webpack_require__(23954);
// EXTERNAL MODULE: ./src/components/Page.js
var Page = __webpack_require__(82771);
// EXTERNAL MODULE: ./src/hooks/useLocales.js + 5 modules
var useLocales = __webpack_require__(9671);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 23 modules
var motion_minimal = __webpack_require__(45962);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(27948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/components/animate/index.js + 16 modules
var animate = __webpack_require__(80104);
;// CONCATENATED MODULE: ./src/sections/about/AboutHero.js



// @mui


// components

// ----------------------------------------------------------------------
var RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        backgroundSize: "cover",
        backgroundPosition: "center top",
        backgroundImage: "url(/team/bg.jpg), url(/team/bg.jpg)",
        padding: theme.spacing(10, 0)
    }, theme.breakpoints.up("md"), {
        height: 560,
        padding: 0
    });
});
var ContentStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        textAlign: "center"
    }, theme.breakpoints.up("md"), {
        textAlign: "left",
        position: "absolute",
        bottom: theme.spacing(10)
    });
});
// ----------------------------------------------------------------------
function AboutHero() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RootStyle, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            component: animate/* MotionContainer */.NM,
            sx: {
                position: "relative",
                height: "100%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentStyle, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(animate/* TextAnimate */.gH, {
                        text: "Ch\xfang t\xf4i",
                        sx: {
                            color: "primary.main"
                        },
                        variants: (0,animate/* varFade */.EU)().inRight
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "inline-flex",
                            color: "common.white"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(animate/* TextAnimate */.gH, {
                                text: "l\xe0",
                                sx: {
                                    mr: 2
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(animate/* TextAnimate */.gH, {
                                text: "ai?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                        variants: (0,animate/* varFade */.EU)().inRight,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "h4",
                            sx: {
                                mt: 5,
                                color: "common.white",
                                fontWeight: "fontWeightMedium"
                            },
                            children: [
                                "H\xe3y l\xe0m việc c\xf9ng nhau v\xe0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                " tạo trang web tuyệt vời một c\xe1ch dễ d\xe0ng"
                            ]
                        })
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./src/components/Image.js
var Image = __webpack_require__(65907);
// EXTERNAL MODULE: ./src/components/carousel/index.js + 3 modules
var carousel = __webpack_require__(94920);
;// CONCATENATED MODULE: ./src/sections/about/AboutTeam.js







// @mui


// components



// ----------------------------------------------------------------------
var _carouselsMembers = [
    {
        id: 0,
        name: "Thanh",
        role: "CEO",
        avatar: "/team/member-t.jpg"
    },
    {
        id: 1,
        name: "PTIT.Hảo",
        role: "Team Leader",
        avatar: "/team/member-1.jpg"
    },
    {
        id: 2,
        name: "BK.Dũng",
        role: "Developer Fullstack",
        avatar: "/team/member-2.jpg"
    },
    {
        id: 3,
        name: "JTeam",
        role: "Education",
        avatar: "/team/member-4.jpg"
    }
];
function AboutTeam() {
    var carouselRef = (0,react.useRef)(null);
    var theme = (0,useTheme/* default */.Z)();
    var settings = {
        arrows: false,
        slidesToShow: 4,
        centerMode: true,
        centerPadding: "0px",
        rtl: Boolean(theme.direction === "rtl"),
        responsive: [
            {
                breakpoint: 1279,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 959,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }, 
        ]
    };
    var handlePrevious = function() {
        var ref;
        (ref = carouselRef.current) === null || ref === void 0 ? void 0 : ref.slickPrev();
    };
    var handleNext = function() {
        var ref;
        (ref = carouselRef.current) === null || ref === void 0 ? void 0 : ref.slickNext();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        component: animate/* MotionViewport */.DG,
        sx: {
            pb: 10,
            textAlign: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                variants: (0,animate/* varFade */.EU)().inDown,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    component: "p",
                    variant: "overline",
                    sx: {
                        mb: 2,
                        color: "text.secondary"
                    },
                    children: "Điều ch\xfang t\xf4i mong muốn"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                variants: (0,animate/* varFade */.EU)().inUp,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h2",
                    sx: {
                        mb: 3
                    },
                    children: "Ch\xeca kh\xf3a dẫn tới sự th\xe0nh c\xf4ng"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                variants: (0,animate/* varFade */.EU)().inUp,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    sx: {
                        mx: "auto",
                        maxWidth: 630,
                        color: function(theme) {
                            return theme.palette.mode === "light" ? "text.secondary" : "common.white";
                        }
                    },
                    children: "JMaster.io sẽ hỗ trợ bạn nếu bạn gặp bất kỳ vấn đề n\xe0o, nh\xf3m hỗ trợ của ch\xfang t\xf4i sẽ trả lời trong v\xf2ng một ng\xe0y v\xe0 ch\xfang t\xf4i cũng c\xf3 t\xe0i liệu chi tiết."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    position: "relative"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* CarouselArrows */.i5, {
                    filled: true,
                    onNext: handleNext,
                    onPrevious: handlePrevious,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        ref: carouselRef
                    }, settings), {
                        children: _carouselsMembers.map(function(member) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                component: motion_minimal.m.div,
                                variants: (0,animate/* varFade */.EU)().in,
                                sx: {
                                    px: 1.5,
                                    py: 10
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MemberCard, {
                                    member: member
                                })
                            }, member.id);
                        })
                    }))
                })
            })
        ]
    });
}
// ----------------------------------------------------------------------
MemberCard.propTypes = {
    member: prop_types_default().shape({
        avatar: (prop_types_default()).string,
        name: (prop_types_default()).string,
        role: (prop_types_default()).string
    })
};
function MemberCard(param) {
    var member = param.member;
    var name = member.name, role = member.role, avatar = member.avatar;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        sx: {
            p: 1
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "subtitle1",
                sx: {
                    mt: 2,
                    mb: 0.5
                },
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body2",
                sx: {
                    mb: 2,
                    color: "text.secondary"
                },
                children: role
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                alt: name,
                src: avatar,
                ratio: "1/1",
                sx: {
                    borderRadius: 1.5
                }
            })
        ]
    }, name);
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
;// CONCATENATED MODULE: ./src/sections/about/AboutVision.js


// @mui

// components


// ----------------------------------------------------------------------
function AboutVision() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        component: animate/* MotionViewport */.DG,
        sx: {
            mt: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    mb: 2,
                    position: "relative",
                    borderRadius: 2,
                    overflow: "hidden"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/team/team.jpg",
                        alt: "about-vision",
                        effect: "black-and-white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            bottom: {
                                xs: 24,
                                md: 80
                            },
                            width: "100%",
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                            position: "absolute",
                            justifyContent: "center"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                        variants: (0,animate/* varFade */.EU)().inUp,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h3",
                            sx: {
                                textAlign: "center"
                            },
                            children: "Ch\xfang t\xf4i cung cấp sản phẩm gi\xe1o dục"
                        })
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(50122);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(27192);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(28979);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(76087);
;// CONCATENATED MODULE: ./node_modules/@mui/material/LinearProgress/linearProgressClasses.js

function getLinearProgressUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiLinearProgress', slot);
}
const linearProgressClasses = (0,generateUtilityClasses/* default */.Z)('MuiLinearProgress', ['root', 'colorPrimary', 'colorSecondary', 'determinate', 'indeterminate', 'buffer', 'query', 'dashed', 'dashedColorPrimary', 'dashedColorSecondary', 'bar', 'barColorPrimary', 'barColorSecondary', 'bar1Indeterminate', 'bar1Determinate', 'bar1Buffer', 'bar2Indeterminate', 'bar2Buffer']);
/* harmony default export */ var LinearProgress_linearProgressClasses = ((/* unused pure expression or super */ null && (linearProgressClasses)));
;// CONCATENATED MODULE: ./node_modules/@mui/material/LinearProgress/LinearProgress.js


const _excluded = ["className", "color", "value", "valueBuffer", "variant"];

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4,
    _t5,
    _t6;













const TRANSITION_DURATION = 4; // seconds

const indeterminate1Keyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t || (_t = _`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`));
const indeterminate2Keyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t2 || (_t2 = _`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`));
const bufferKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t3 || (_t3 = _`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`));

const useUtilityClasses = ownerState => {
  const {
    classes,
    variant,
    color
  } = ownerState;
  const slots = {
    root: ['root', `color${(0,capitalize/* default */.Z)(color)}`, variant],
    dashed: ['dashed', `dashedColor${(0,capitalize/* default */.Z)(color)}`],
    bar1: ['bar', `barColor${(0,capitalize/* default */.Z)(color)}`, (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate', variant === 'determinate' && 'bar1Determinate', variant === 'buffer' && 'bar1Buffer'],
    bar2: ['bar', variant !== 'buffer' && `barColor${(0,capitalize/* default */.Z)(color)}`, variant === 'buffer' && `color${(0,capitalize/* default */.Z)(color)}`, (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate', variant === 'buffer' && 'bar2Buffer']
  };
  return (0,composeClasses/* default */.Z)(slots, getLinearProgressUtilityClass, classes);
};

const getColorShade = (theme, color) => {
  if (color === 'inherit') {
    return 'currentColor';
  }

  return theme.palette.mode === 'light' ? (0,colorManipulator/* lighten */.$n)(theme.palette[color].main, 0.62) : (0,colorManipulator/* darken */._j)(theme.palette[color].main, 0.5);
};

const LinearProgressRoot = (0,styled/* default */.ZP)('span', {
  name: 'MuiLinearProgress',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`], styles[ownerState.variant]];
  }
})(({
  ownerState,
  theme
}) => (0,esm_extends/* default */.Z)({
  position: 'relative',
  overflow: 'hidden',
  display: 'block',
  height: 4,
  zIndex: 0,
  // Fix Safari's bug during composition of different paint.
  '@media print': {
    colorAdjust: 'exact'
  },
  backgroundColor: getColorShade(theme, ownerState.color)
}, ownerState.color === 'inherit' && ownerState.variant !== 'buffer' && {
  backgroundColor: 'none',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'currentColor',
    opacity: 0.3
  }
}, ownerState.variant === 'buffer' && {
  backgroundColor: 'transparent'
}, ownerState.variant === 'query' && {
  transform: 'rotate(180deg)'
}));
const LinearProgressDashed = (0,styled/* default */.ZP)('span', {
  name: 'MuiLinearProgress',
  slot: 'Dashed',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.dashed, styles[`dashedColor${(0,capitalize/* default */.Z)(ownerState.color)}`]];
  }
})(({
  ownerState,
  theme
}) => {
  const backgroundColor = getColorShade(theme, ownerState.color);
  return (0,esm_extends/* default */.Z)({
    position: 'absolute',
    marginTop: 0,
    height: '100%',
    width: '100%'
  }, ownerState.color === 'inherit' && {
    opacity: 0.3
  }, {
    backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
    backgroundSize: '10px 10px',
    backgroundPosition: '0 -23px'
  });
}, (0,emotion_react_browser_esm/* css */.iv)(_t4 || (_t4 = _`
    animation: ${0} 3s infinite linear;
  `), bufferKeyframe));
const LinearProgressBar1 = (0,styled/* default */.ZP)('span', {
  name: 'MuiLinearProgress',
  slot: 'Bar1',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.bar, styles[`barColor${(0,capitalize/* default */.Z)(ownerState.color)}`], (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate, ownerState.variant === 'determinate' && styles.bar1Determinate, ownerState.variant === 'buffer' && styles.bar1Buffer];
  }
})(({
  ownerState,
  theme
}) => (0,esm_extends/* default */.Z)({
  width: '100%',
  position: 'absolute',
  left: 0,
  bottom: 0,
  top: 0,
  transition: 'transform 0.2s linear',
  transformOrigin: 'left',
  backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : theme.palette[ownerState.color].main
}, ownerState.variant === 'determinate' && {
  transition: `transform .${TRANSITION_DURATION}s linear`
}, ownerState.variant === 'buffer' && {
  zIndex: 1,
  transition: `transform .${TRANSITION_DURATION}s linear`
}), ({
  ownerState
}) => (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && (0,emotion_react_browser_esm/* css */.iv)(_t5 || (_t5 = _`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), indeterminate1Keyframe));
const LinearProgressBar2 = (0,styled/* default */.ZP)('span', {
  name: 'MuiLinearProgress',
  slot: 'Bar2',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.bar, styles[`barColor${(0,capitalize/* default */.Z)(ownerState.color)}`], (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate, ownerState.variant === 'buffer' && styles.bar2Buffer];
  }
})(({
  ownerState,
  theme
}) => (0,esm_extends/* default */.Z)({
  width: '100%',
  position: 'absolute',
  left: 0,
  bottom: 0,
  top: 0,
  transition: 'transform 0.2s linear',
  transformOrigin: 'left'
}, ownerState.variant !== 'buffer' && {
  backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : theme.palette[ownerState.color].main
}, ownerState.color === 'inherit' && {
  opacity: 0.3
}, ownerState.variant === 'buffer' && {
  backgroundColor: getColorShade(theme, ownerState.color),
  transition: `transform .${TRANSITION_DURATION}s linear`
}), ({
  ownerState
}) => (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && (0,emotion_react_browser_esm/* css */.iv)(_t6 || (_t6 = _`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), indeterminate2Keyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

const LinearProgress = /*#__PURE__*/react.forwardRef(function LinearProgress(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiLinearProgress'
  });

  const {
    className,
    color = 'primary',
    value,
    valueBuffer,
    variant = 'indeterminate'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    variant
  });

  const classes = useUtilityClasses(ownerState);
  const theme = (0,useTheme/* default */.Z)();
  const rootProps = {};
  const inlineStyles = {
    bar1: {},
    bar2: {}
  };

  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      rootProps['aria-valuemin'] = 0;
      rootProps['aria-valuemax'] = 100;
      let transform = value - 100;

      if (theme.direction === 'rtl') {
        transform = -transform;
      }

      inlineStyles.bar1.transform = `translateX(${transform}%)`;
    } else if (false) {}
  }

  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      let transform = (valueBuffer || 0) - 100;

      if (theme.direction === 'rtl') {
        transform = -transform;
      }

      inlineStyles.bar2.transform = `translateX(${transform}%)`;
    } else if (false) {}
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(LinearProgressRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    role: "progressbar"
  }, rootProps, {
    ref: ref
  }, other, {
    children: [variant === 'buffer' ? /*#__PURE__*/(0,jsx_runtime.jsx)(LinearProgressDashed, {
      className: classes.dashed,
      ownerState: ownerState
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(LinearProgressBar1, {
      className: classes.bar1,
      ownerState: ownerState,
      style: inlineStyles.bar1
    }), variant === 'determinate' ? null : /*#__PURE__*/(0,jsx_runtime.jsx)(LinearProgressBar2, {
      className: classes.bar2,
      ownerState: ownerState,
      style: inlineStyles.bar2
    })]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var LinearProgress_LinearProgress = (LinearProgress);
// EXTERNAL MODULE: ./src/hooks/useResponsive.js
var useResponsive = __webpack_require__(55102);
// EXTERNAL MODULE: ./src/utils/formatNumber.js
var formatNumber = __webpack_require__(87850);
// EXTERNAL MODULE: ./src/components/Iconify.js + 1 modules
var Iconify = __webpack_require__(34444);
;// CONCATENATED MODULE: ./src/sections/about/AboutWhat.js





// @mui


// hooks

// utils

// components



// ----------------------------------------------------------------------
var _skills = (0,_to_consumable_array/* default */.Z)(Array(3)).map(function(_, index) {
    return {
        label: [
            "Software",
            "Education",
            "Marketing"
        ][index],
        value: 100
    };
});
var AboutWhat_RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        textAlign: "center",
        paddingTop: theme.spacing(10),
        paddingBottom: theme.spacing(5)
    }, theme.breakpoints.up("md"), {
        textAlign: "left"
    });
});
// ----------------------------------------------------------------------
function AboutWhat() {
    var theme = (0,useTheme/* default */.Z)();
    var isDesktop = (0,useResponsive/* default */.Z)("up", "md");
    var isLight = theme.palette.mode === "light";
    var shadow = "-40px 40px 80px ".concat((0,colorManipulator/* alpha */.Fq)(isLight ? theme.palette.grey[500] : theme.palette.common.black, 0.48));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutWhat_RootStyle, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            component: animate/* MotionViewport */.DG,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                spacing: 3,
                children: [
                    isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        md: 6,
                        lg: 7,
                        sx: {
                            pr: {
                                md: 7
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            container: true,
                            spacing: 3,
                            alignItems: "flex-end",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                        variants: (0,animate/* varFade */.EU)().inUp,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            alt: "our office 1",
                                            src: "/team/member-3.jpg",
                                            ratio: "3/4",
                                            sx: {
                                                borderRadius: 2,
                                                boxShadow: shadow
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                        variants: (0,animate/* varFade */.EU)().inUp,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            alt: "our office 2",
                                            src: "/team/member-x.jpg",
                                            ratio: "1/1",
                                            sx: {
                                                borderRadius: 2
                                            }
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        md: 6,
                        lg: 5,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                variants: (0,animate/* varFade */.EU)().inRight,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h2",
                                    sx: {
                                        mb: 3
                                    },
                                    children: "Về JMaster.io?"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                variants: (0,animate/* varFade */.EU)().inRight,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        color: function(theme) {
                                            return theme.palette.mode === "light" ? "text.secondary" : "common.white";
                                        }
                                    },
                                    children: "Đội ngũ ph\xe1t triển của ch\xfang t\xf4i l\xe0 một đội h\xecnh đầy đủ v\xe0 đam m\xea, tập trung v\xe0o việc tạo ra c\xe1c giải ph\xe1p c\xf4ng nghệ ti\xean tiến để đ\xe1p ứng c\xe1c y\xeau cầu phức tạp của kh\xe1ch h\xe0ng. Với sự kết hợp giữa kiến thức chuy\xean m\xf4n v\xe0 kỹ năng kỹ thuật s\xe1ng tạo, ch\xfang t\xf4i cam kết cung cấp những sản phẩm v\xe0 dịch vụ chất lượng cao.."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    my: 5
                                },
                                children: _skills.map(function(progress) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                        variants: (0,animate/* varFade */.EU)().inRight,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressItem, {
                                            progress: progress
                                        })
                                    }, progress.label);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                variants: (0,animate/* varFade */.EU)().inRight,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "https://jmaster.io",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: "outlined",
                                        color: "inherit",
                                        size: "large",
                                        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                            icon: "ic:round-arrow-right-alt",
                                            width: 24,
                                            height: 24
                                        }),
                                        children: "Đi tới JMaster.io"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
// ----------------------------------------------------------------------
ProgressItem.propTypes = {
    progress: prop_types_default().shape({
        label: (prop_types_default()).string,
        value: (prop_types_default()).number
    })
};
function ProgressItem(param) {
    var progress = param.progress;
    var label = progress.label, value = progress.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            mt: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    mb: 1.5,
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "subtitle2",
                        children: [
                            label,
                            "\xa0-\xa0"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            color: "text.secondary"
                        },
                        children: (0,formatNumber/* fPercent */.f2)(value)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinearProgress_LinearProgress, {
                variant: "determinate",
                value: value,
                sx: {
                    "& .MuiLinearProgress-bar": {
                        bgcolor: "grey.700"
                    },
                    "&.MuiLinearProgress-determinate": {
                        bgcolor: "divider"
                    }
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/about/index.js





;// CONCATENATED MODULE: ./src/pages/about-us.js
// @mui




// layouts

// components

// sections


// ----------------------------------------------------------------------
var about_us_RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        paddingTop: theme.spacing(8)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(11)
    });
});
// ----------------------------------------------------------------------
About.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* default */.Z, {
        variant: "main",
        children: page
    });
};
// ----------------------------------------------------------------------
function About() {
    var translate = (0,useLocales/* default */.Z)().translate;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        title: translate("aboutus.title"),
        description: translate("aboutus.description"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(about_us_RootStyle, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutHero, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutWhat, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutVision, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                    orientation: "horizontal",
                    sx: {
                        my: 5,
                        mx: "auto",
                        width: 100
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutTeam, {})
            ]
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5101,6429,6066,6805,9774,2888,179], function() { return __webpack_exec__(72879); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);